import { useMutation } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";

import type { Note, SingleUserNoteResponse } from "./types";

type StoredToken = {
  AccessToken?: string;
};

export type EditUserNotePayload = {
  user_id: string;
  note_id: string;
  body: string;
};

const editUserNote = async ({
  user_id,
  note_id,
  body,
}: EditUserNotePayload): Promise<Note | null> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString
    ? JSON.parse(tokenString)
    : null;
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(
    token?.AccessToken,
  );

  const response = await PrivateAdminPanelInstance.patch(
    API_ROUTES.EDIT_USER_NOTE.replace("{user_id}", user_id).replace(
      "{note_id}",
      note_id,
    ),
    { body },
  );

  const responseBody = response?.data as
    | Partial<SingleUserNoteResponse>
    | undefined;

  return (responseBody?.data as Note | undefined) ?? null;
};

export const useEditUserNote = () =>
  useMutation<Note | null, Error, EditUserNotePayload>({
    mutationKey: ["editUserNote"],
    mutationFn: editUserNote,
  });
